/**
 * Shared "product info" quick view modal controller.
 * Generic open/close/carousel behavior only — extracted from Build Box
 * (new-bundle.liquid) so any section can reuse the exact same modal
 * component (see snippets/product-info-modal.liquid) instead of
 * duplicating markup/CSS/JS.
 *
 * The CTA is intentionally NOT handled here: clicking
 * `.product-info-modal__atc` just dispatches a `product-info-modal:atc`
 * document event carrying the product/variant data and the modal's
 * `data-context` attribute, then closes the modal. Each context (Build
 * Box, PDP Bundle, ...) listens for that event and decides what "add"
 * means for it — this is what makes the component reusable without
 * baking any one context's business logic into it.
 */
(function () {
  'use strict';

  function closeModal(modal) {
    modal.classList.remove('active');
    document.body.style.overflow = '';
  }

  function updateCarouselNavVisibility(scope) {
    var carousels = (scope || document).querySelectorAll('.product-info-modal__carousel');
    carousels.forEach(function (carousel) {
      var slides = carousel.querySelectorAll('.carousel-slide');
      var wrapper = carousel.closest('.product-info-modal__carousel-wrapper');
      if (!wrapper) return;
      var navBtns = wrapper.querySelectorAll('.carousel-nav');
      var display = slides.length <= 1 ? 'none' : 'flex';
      navBtns.forEach(function (btn) {
        btn.style.display = display;
      });
    });
  }

  function openModal(modal) {
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';

    // Remove only the last "| FLASH SALE" part of the title, if present.
    var titleElement = modal.querySelector('.product-info-modal__title h2');
    if (titleElement) {
      titleElement.textContent = titleElement.textContent
        .replace(/\s*\|\s*FLASH\s+SALE\s*$/gi, '')
        .trim();
    }

    updateCarouselNavVisibility(modal);

    document.dispatchEvent(new CustomEvent('product-info-modal:open', {
      detail: {
        productId: modal.getAttribute('data-product-id'),
        context: modal.getAttribute('data-context'),
        modal: modal
      }
    }));
  }

  function findModal(productId) {
    return document.querySelector('.product-info-modal[data-product-id="' + productId + '"]');
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateCarouselNavVisibility();

    document.querySelectorAll('.product-info-modal').forEach(function (modal) {
      var observer = new MutationObserver(function () {
        updateCarouselNavVisibility(modal);
      });
      observer.observe(modal, { childList: true, subtree: true });
    });
  });

  // Open via a dedicated trigger element, e.g. a "quick view" / info button.
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-view-trigger]');
    if (!trigger) return;
    var productId = trigger.getAttribute('data-product-id');
    if (!productId) return;
    e.preventDefault();
    var modal = findModal(productId);
    if (modal) openModal(modal);
  });

  // Open via whole-card click — opt-in per card via data-quick-view-card,
  // skipping clicks on any button/link inside it.
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-quick-view-card]');
    if (!card) return;
    if (e.target.closest('button') || e.target.closest('a')) return;
    var productId = card.getAttribute('data-product-id');
    if (!productId) return;
    var modal = findModal(productId);
    if (modal) openModal(modal);
  });

  // Close via the close button or a direct click on the overlay.
  document.addEventListener('click', function (e) {
    var closeBtn = e.target.closest('.product-info-modal__close');
    if (closeBtn) {
      var modal = closeBtn.closest('.product-info-modal');
      if (modal) closeModal(modal);
      return;
    }

    if (e.target.classList.contains('product-info-modal__overlay')) {
      var overlayModal = e.target.closest('.product-info-modal');
      if (overlayModal) closeModal(overlayModal);
    }
  });

  // Carousel prev/next.
  document.addEventListener('click', function (e) {
    var navBtn = e.target.closest('.carousel-nav');
    if (!navBtn) return;

    var wrapper = navBtn.closest('.product-info-modal__carousel-wrapper');
    var carousel = wrapper && wrapper.querySelector('.product-info-modal__carousel');
    var firstSlide = carousel && carousel.querySelector('.carousel-slide');
    if (!carousel || !firstSlide) return;

    var scrollAmount = firstSlide.offsetWidth;
    carousel.scrollBy({
      left: navBtn.classList.contains('carousel-nav--next') ? scrollAmount : -scrollAmount,
      behavior: 'smooth'
    });
  });

  // CTA: dispatch, let the owning context handle "add", then close.
  document.addEventListener('click', function (e) {
    if (!e.target.classList.contains('product-info-modal__atc')) return;

    var button = e.target;
    var modal = button.closest('.product-info-modal');
    if (!modal) return;

    document.dispatchEvent(new CustomEvent('product-info-modal:atc', {
      detail: {
        productId: modal.getAttribute('data-product-id'),
        context: modal.getAttribute('data-context'),
        variantId: button.getAttribute('data-variant-id'),
        price: button.getAttribute('data-price'),
        title: button.getAttribute('data-title'),
        variantImage: button.getAttribute('data-variant-image'),
        mrp: button.getAttribute('data-mrp'),
        modal: modal,
        button: button
      }
    }));

    closeModal(modal);
  });
})();
